import { ContextService } from '../../../services/context_service';
import { DatenverwaltungKlimafaktorenIntern } from './DatenverwaltungKlimafaktorenIntern';
import { DatenverwaltungKlimagaseArt } from './DatenverwaltungKlimagaseArt';
import { DatenverwaltungKlimaScope3 } from './DatenverwaltungKlimaScope3';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { WGallery } from '../../../core/gallery/WGallery';

interface DatenverwaltungKlimaProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface DatenverwaltungKlimaState {
    tabIndex: number;
}

export class DatenverwaltungKlima extends React.Component<DatenverwaltungKlimaProps, DatenverwaltungKlimaState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.datenverwaltung'/*'admin.tab.datenverwaltung.co2'*/;
    private rechte: any = {};
    private scope3Entities: any = {
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL]: { name: '1. Materialien / Produkte' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER]: { name: '2. Güter' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT]: { name: '4./9. Transporte' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE]: { name: '5. Abfälle' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG]: { name: '6. Reisen/Entfernung' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_UEBERNACHTUNG]: { name: '6. Reisen/Übernachtung' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_PENDELN]: { name: '7. Pendeln' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT_UNTERKUNFT]: { name: '6./9. Unterkunft' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_RAEUMLICHKEITEN]: { name: 'Angem. Räumlichlichlichkeiten' },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_FAHRZEUGE]: { name: 'Angem. Fahrzeuge' }
    };
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_FAKTOREN_KLIMAGASE },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_FAKTOREN_BRENNSTOFFE },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_MATERIALIEN },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_GUETER },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_TRANSPORTE },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ABFAELLE },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_REISEN_ENTFERNUNG },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_REISEN_UEBERNACHTUNG },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_PENDELN },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_UNTERKUNFT },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_RAEUMLICHKEITEN },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_FAHRZEUGE },
        { path: RoutingIDs.ROUTE_CO2_FUSSABDRUCK_DATEIABLAGE }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2', 'co2'
    ];

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.co2}>Faktoren Klimagase (S1)</Tab>
                    <Tab disabled={!this.rechte.co2}>Faktoren Brennstoffe (S1 / S2 / S3)</Tab>
                    {this.renderTabs()}
                    <Tab disabled={!this.rechte.co2}>Template-Dateien</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.co2 &&
                        <DatenverwaltungKlimagaseArt data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.co2 &&
                        <DatenverwaltungKlimafaktorenIntern data={this.props.data} />
                    }
                </TabPanel>
                {this.renderTabPanels()}
                <TabPanel>
                    {this.rechte.co2 &&
                        <WGallery
                            title='Template-Dateien'
                            entity='no_ent_co2_faktoren'
                            module={IDs.MOD_ETOOL_ADMIN}
                            tid={9999}
                            view={WGallery.VIEW_ICONS}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    renderTabPanels(): JSX.Element[] {
        return Object.keys(this.scope3Entities).map((entity: string, index: number) =>
            <TabPanel key={`panel-${index}`}>
                {this.rechte[this.tabs[index + 2]] &&
                    <DatenverwaltungKlimaScope3
                        data={this.props.data}
                        entity={entity}
                    />
                }
            </TabPanel>
        );
    }

    renderTabs(): JSX.Element[] {
        return Object.keys(this.scope3Entities).map((entity: string, index: number) =>
            <Tab
                key={`tab-${index}`}
                disabled={!this.rechte[this.tabs[index + 2]]}
            >
                {this.scope3Entities[entity].name} (S3)
            </Tab>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
